import FilterAggregator from './FilterAggregator';

export default FilterAggregator;
